import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { ScrollArea } from "@shared/ui/scroll-area";
import { NumberFormat } from "../../../types";

interface FormatDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  formatData: NumberFormat | null; // Changed to receive complete data
}

const FormatDetailsModal = ({
  isOpen,
  onClose,
  formatData,
}: FormatDetailsModalProps) => {
  if (!formatData) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Format Details: {formatData.submodule}</DialogTitle>
          <DialogDescription>
            Complete configuration for this ID format
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-[550px] pr-4">
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Entity
                </p>
                <p className="text-sm font-semibold">{formatData.submodule}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Type
                </p>
                <p className="text-sm font-semibold capitalize">
                  {formatData.configurationType === 0
                    ? "Master"
                    : "Transaction"}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Module
                </p>
                <p className="text-sm font-semibold">{formatData.module}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Prefix
                </p>
                <p className="text-sm font-semibold">
                  {formatData.prefix || "None"}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Date Element
                </p>
                <p className="text-sm font-semibold">
                  {formatData.dateElement || "None"}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Separator
                </p>
                <p className="text-sm font-semibold">
                  {formatData.separator || "None"}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Sequence Length
                </p>
                <p className="text-sm font-semibold">{formatData.length}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Starting Number
                </p>
                <p className="text-sm font-semibold">{formatData.startingno}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Current Number
                </p>
                <p className="text-sm font-semibold">{formatData.currentno}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Utility Service
                </p>
                <p className="text-sm font-semibold">
                  {formatData.utilityService || "None"}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Status
                </p>
                <p className="text-sm font-semibold">
                  {formatData.isActive ? "Active" : "Inactive"}
                </p>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t">
              <p className="text-sm font-medium text-muted-foreground">
                Format Preview
              </p>
              <p className="text-lg font-mono bg-gray-100 p-2 rounded mt-2 text-center">
                {formatData.formatPreview || "No preview available"}
              </p>
            </div>

            <div className="mt-4 pt-4 border-t">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Created Date
                  </p>
                  <p className="text-sm">
                    {formatData.createdUser?.createdDate || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Created By
                  </p>
                  <p className="text-sm">
                    {formatData.createdUser?.name || "Unknown"}
                  </p>
                </div>
              </div>
            </div>

            {/* Additional details */}
            <div className="mt-4 pt-4 border-t">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Utility ID
                  </p>
                  <p className="text-sm">{formatData.utility}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Module ID
                  </p>
                  <p className="text-sm">{formatData.moduleId}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Submodule ID
                  </p>
                  <p className="text-sm">{formatData.submoduleId}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    Has Prefix
                  </p>
                  <p className="text-sm">
                    {formatData.isPrefix ? "Yes" : "No"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default FormatDetailsModal;
